import type { ThreadsActions } from '@store/reducers/threads'
import { InternalThreadsActions } from '@store/reducers/threads/actions'
import { SocketActions } from '@store/socketSaga'
import { call, put } from 'redux-saga/effects'

import API from '@/api'

export function* move({ payload }: ReturnType<typeof ThreadsActions.move>) {
  const internalAction = InternalThreadsActions.update(payload)
  yield put(internalAction)

  yield call(API.Threads.move, payload.uuid, payload)

  yield put(
    SocketActions.emit({
      eventName: 'comments',
      payload: internalAction,
    })
  )
}
